import { render } from "./Step2.vue?vue&type=template&id=2239f89d"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/ScalingUp/Step2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2239f89d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2239f89d', __exports__)) {
    api.reload('2239f89d', __exports__)
  }
  
  module.hot.accept("./Step2.vue?vue&type=template&id=2239f89d", () => {
    api.rerender('2239f89d', render)
  })

}


export default __exports__